import React from 'react';
import DefaultLayout from './containers/DefaultLayout';
import UserActivity from "./views/UserActivity/UserActivity";

const Conversations = React.lazy(() => import('./views/Conversations'));
const CallbackService = React.lazy(() => import('./views/CBSA/CBSA'));
const CallbackMetrics = React.lazy(() => import('./views/CBSA/Metrics/Metrics'));
const ScheduledCallback = React.lazy(() => import('./views/CBSA/ScheduledCallback/ScheduledCallbackConfig'));
const Profile = React.lazy(() => import('./views/Users/Profile'));
const Live = React.lazy(() => import('./views/Live/Live'));
const Reporting = React.lazy(() => import('./views/Reporting/Reporting'));
const Recording = React.lazy(() => import('./views/Recording/Recording'));
const IdentityProvider = React.lazy(() => import('./views/IdentityProvider'));
const Trends = React.lazy(() => import('./views/Trends/Trends'));
// const Monitoring = React.lazy(() => import('./views/Monitoring/Monitoring'));
const CallPathsFlow = React.lazy(() => import('./views/Sankey/Sankey'));
const CallPathsEndStates = React.lazy(() => import('./views/Sankey/SankeyCharts'));
const Survey = React.lazy(() => import('./views/Survey'));
const SurveyPage = React.lazy(() => import('./views/SurveyService/Page'));
const ReportDownload = React.lazy(() => import('./views/DownloadPage/DownloadPage'));
const HoursOfOperation = React.lazy(() => import('./views/HoursOfOperation/Home/HOOPage'));
const Logs = React.lazy(()=>import('./views/Logs/Logs'))
const ArchivedLogs = React.lazy(()=>import('./views/Archived-logs/archived-logs'))
const HOOSharedExceptions = React.lazy(() => import('./views/HoursOfOperation/SharedExceptions/SharedExceptionDaysPage'));
const ConfigurationManagerHome = React.lazy(() => import('./views/ConfigurationManager/ConfigurationManager'));

const AdminPage = React.lazy(() => import('./views/Admin/AdminPage'));
// const TestHarness = React.lazy(() => import('./views/TestHarness/TestHarness'));
const ApplicationSettings = React.lazy(() => import('./views/ApplicationSettings/ApplicationSettings'));
const AdminRegister = React.lazy(() => import('./views/Admin/Register'));

const Intents = React.lazy(() => import('./views/Intents'));
const Prompts = React.lazy(() => import('./views/Prompts'));

const AddIntent = React.lazy(() => import('./views/Intents/AddIntent/AddIntent'));
const Import = React.lazy(() => import('./views/Intents/Import'));
const PromptsImport = React.lazy(() => import('./views/Prompts/PromptsImport'));
const IntentDetails = React.lazy(() => import('./views/Intents/IntentDetails/IntentDetails'));
const EntityDetails = React.lazy(() => import('./views/Intents/Entities/EntityDetails'));
const PromptGroups = React.lazy(() => import('./views/Prompts/PromptGroups'));
const Mock2 = React.lazy(() => import('./views/Mock2/Conversations'));

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config

const routes: { [key: string]: { path: string, exact?: boolean, name: string, restricted?: boolean, component: (props: any) => React.ReactNode }[] } = {
  standard: [
    { path: '/', exact: true, name: 'Home', component: DefaultLayout },
    { path: '/identity_provider', name: 'IdentityProvider', component: IdentityProvider},
    { path: '/live', name: 'Live', component: Live},
    { path: '/conversations', exact: true, name: 'Conversations', component: Conversations},
    // { path: '/conversations/:conversationId', name: 'Conversation', component: Conversations},
    { path: '/conversations/createIssue', exact: true, name: 'Issue', component: Conversations},
    { path: '/user_activity', name: 'User Profiles', component: UserActivity},
    { path: '/user/profile', name: 'My Profile', component: Profile},
    { path: '/mock2', name: 'Mock2', component: Mock2 },
    { path: '/prompts', exact :true, name: 'Prompts', component: Prompts},
    { path: '/prompts/import', exact: true ,name: 'Import', component: PromptsImport },
    { path: '/prompts/groups', exact: true , name: 'Prompt Groups', component: PromptGroups },
    // { path: '/user_satisfaction', name: 'User Satisfaction', component: UserSatisfaction },
    { path: '/intents&entities', exact :true, name: 'Intents & Entities', component: Intents},
    { path: '/intents&entities/import', exact :true, name: 'Import', component: Import },
    { path: '/intents&entities/addintent', name: 'Add Intent', component: AddIntent },
    { path: '/intents&entities/intentdetails', name: 'Intent Details', component: IntentDetails },
    { path: '/intents&entities/entitydetails', name: 'Entity Details', component: EntityDetails },
    { path: '/reporting', exact: true, name: 'Reporting', component: Reporting },
    { path: '/recording', exact: false, name: 'Recording', component: Recording },
    { path: '/trends', exact: true, name: 'Trends', component: Trends },
    // { path: '/monitoring', exact: true, name: 'Monitoring', component: Monitoring },
    // { path: '/rasa', exact: true, name: 'Rasa', component: Rasa },
    { path: '/admin', exact: true, name: 'Admin', component: AdminPage, restricted: true },
    { path: '/admin/register', exact: true, name: 'Registration', component: AdminRegister, restricted: true },
    { path: '/ui_settings', exact: true, name: 'UI Settings', component: ApplicationSettings, restricted: true},
    { path: '/flow', exact: true, name: 'Flow', component: CallPathsFlow},
    { path: '/callpaths', exact: true, name: 'CallPaths', component: CallPathsFlow},
    { path: '/end-states', exact: true, name: 'End States', component: CallPathsEndStates},
    { path: '/callback-service', exact: true, name: 'callback-service', component: CallbackService},
    { path: '/callback-metrics', name: "callback-metrics", component: CallbackMetrics},
    { path: '/scheduled-callback', name: "scheduled-callback", component: ScheduledCallback},
    { path: '/survey', exact: true, name: 'survey', component: Survey},
    { path: '/vss/designer', exact: true, name: 'survey-service', component: SurveyPage},
    { path: '/report_download', exact: false, name: 'report_download', component: ReportDownload},
    { path: '/hours_of_operation', exact: true, name: 'hours_of_operation', component: HoursOfOperation},
    { path: '/hoo_shared_exception_days', exact: true, name: 'shared_exception_days', component: HOOSharedExceptions},
    {path:'/logs', exact:true, name: 'logs', component: Logs},
    {path:'/archived-logs', exact:true, name: 'logs', component: ArchivedLogs},
    { path: '/configuration-manager-home', exact: true, name: 'configuration-manager-home', component: ConfigurationManagerHome},
  ],
  syf: [
    { path: '/', exact: true, name: 'Home', component: DefaultLayout },
    { path: '/identity_provider', name: 'IdentityProvider', component: IdentityProvider},
    //{ path: '/live', name: 'Live', component: Live},
    { path: '/conversations', exact: true, name: 'Conversations', component: Conversations},
    // { path: '/conversations/:conversationId', name: 'Conversation', component: Conversations},
    { path: '/conversations/createIssue', exact: true, name: 'Issue', component: Conversations},
    { path: '/user_activity', name: 'User Profiles', component: UserActivity},
    { path: '/user/profile', name: 'My Profile', component: Profile},
    { path: '/mock2', name: 'Mock2', component: Mock2 },
    { path: '/prompts', exact :true, name: 'Prompts', component: Prompts},
    { path: '/prompts/import', exact: true ,name: 'Import', component: PromptsImport },
    { path: '/prompts/groups', exact: true , name: 'Prompt Groups', component: PromptGroups },
    // { path: '/user_satisfaction', name: 'User Satisfaction', component: UserSatisfaction },
    { path: '/intents&entities', exact :true, name: 'Intents & Entities', component: Intents},
    { path: '/intents&entities/import', exact :true, name: 'Import', component: Import },
    { path: '/intents&entities/addintent', name: 'Add Intent', component: AddIntent },
    { path: '/intents&entities/intentdetails', name: 'Intent Details', component: IntentDetails },
    { path: '/intents&entities/entitydetails', name: 'Entity Details', component: EntityDetails },
    { path: '/reporting', exact: true, name: 'Reporting', component: Reporting },
    { path: '/recording', exact: false, name: 'Recording', component: Recording },
    { path: '/trends', exact: true, name: 'Trends', component: Trends },
    // { path: '/monitoring', exact: true, name: 'Monitoring', component: Monitoring },
    // { path: '/rasa', exact: true, name: 'Rasa', component: Rasa },
    { path: '/admin', exact: true, name: 'Admin', component: AdminPage, restricted: true },
    { path: '/admin/register', exact: true, name: 'Registration', component: AdminRegister, restricted: true },
    { path: '/ui_settings', exact: true, name: 'UI Settings', component: ApplicationSettings, restricted: true},
    { path: '/flow', exact: true, name: 'Flow', component: CallPathsFlow},
    { path: '/callpaths', exact: true, name: 'CallPaths', component: CallPathsFlow},
    { path: '/end-states', exact: true, name: 'End States', component: CallPathsEndStates},
    { path: '/callback-service', exact: true, name: 'callback-service', component: CallbackService},
    { path: '/callback-metrics', name: "callback-metrics", component: CallbackMetrics},
    { path: '/scheduled-callback', name: "scheduled-callback", component: ScheduledCallback},
    { path: '/survey', exact: true, name: 'survey', component: Survey},
    { path: '/vss/designer', exact: true, name: 'survey-service', component: SurveyPage},
    { path: '/report_download', exact: false, name: 'report_download', component: ReportDownload},
    { path: '/hours_of_operation', exact: true, name: 'hours_of_operation', component: HoursOfOperation},
    { path: '/hoo_shared_exception_days', exact: true, name: 'shared_exception_days', component: HOOSharedExceptions},
    {path:'/logs', exact:true, name: 'logs', component: Logs},
    {path:'/archived-logs', exact:true, name: 'logs', component: ArchivedLogs},
    { path: '/configuration-manager-home', exact: true, name: 'configuration-manager-home', component: ConfigurationManagerHome},
  
  ],
  cbsaOnly: [
    { path: '/', exact: true, name: 'Home', component: DefaultLayout },
    { path: '/callback-service', exact: true, name: 'callback-service', component: CallbackService},
    { path: '/callback-metrics', name: "callback-metrics", component: CallbackMetrics},
    { path: '/scheduled-callback', name: "scheduled-callback", component: ScheduledCallback},
    { path: '/hours_of_operation', exact: true, name: 'hours_of_operation', component: HoursOfOperation},
    { path: '/hoo_shared_exception_days', exact: true, name: 'shared_exception_days', component: HOOSharedExceptions},
    { path: '/configuration-manager-home', exact: true, name: 'configuration-manager-home', component: ConfigurationManagerHome},
    { path: '/admin', exact: true, name: 'Admin', component: AdminPage, restricted: true },
    { path: '/admin/register', exact: true, name: 'Registration', component: AdminRegister, restricted: true },
    { path: '/ui_settings', exact: true, name: 'UI Settings', component: ApplicationSettings, restricted: true},
  ]
}

export default routes;
